import {
  getCurrencyForIso,
  resolveCountryMeta,
  sortedCountries,
} from "./countryCurrency";
import { getClientCountryFromRecord } from "./applicationCostHelpers";
import { findGstSettingByCurrency } from "./gstCalculation";

export function normalizeGstSettingsList(response) {
  if (response?.data?.status && Array.isArray(response?.data?.data)) {
    return response.data.data;
  }

  const payload = response?.data?.data;

  if (Array.isArray(payload)) {
    return payload;
  }

  if (payload && Array.isArray(payload.data)) {
    return payload.data;
  }

  if (Array.isArray(response?.data)) {
    return response.data;
  }

  return [];
}

/** @deprecated Use normalizeGstSettingsList */
export const normalizeActiveGstSettings = normalizeGstSettingsList;

export function resolveGstPercentageForCurrency(
  currencyCode = "AUD",
  gstSettings = [],
) {
  const setting = findGstSettingByCurrency(gstSettings, currencyCode);
  return Number(setting?.gst_percentage) || 0;
}

export function resolveGstSettingForCurrency(currencyCode = "AUD", gstSettings = []) {
  return findGstSettingByCurrency(gstSettings, currencyCode);
}

const PRIORITY_CURRENCIES = [
  "AUD",
  "GBP",
  "PKR",
  "USD",
  "EUR",
  "CAD",
  "NZD",
  "SGD",
  "AED",
  "MYR",
  "INR",
  "CNY",
  "JPY",
  "HKD",
  "CHF",
  "ZAR",
  "BDT",
  "LKR",
  "NPR",
];

export const INVOICE_AMOUNTS_ARE_OPTIONS = [
  { value: "inclusive", label: "Tax inclusive" },
  { value: "exclusive", label: "Tax exclusive" },
  { value: "notax", label: "No tax" },
];

let currencyDisplayNames;

function getCurrencyDisplayName(code) {
  if (!code) return "";
  try {
    if (!currencyDisplayNames) {
      currencyDisplayNames = new Intl.DisplayNames(["en"], {
        type: "currency",
      });
    }
    const name = currencyDisplayNames.of(code);
    return name ? `${name} (${code})` : code;
  } catch {
    return code;
  }
}

export function buildInvoiceCurrencyOptions() {
  const fromCountries = sortedCountries
    .map((country) => getCurrencyForIso(country.IsoCode))
    .filter(Boolean);
  const unique = [
    ...new Set([...PRIORITY_CURRENCIES, ...fromCountries]),
  ].filter(Boolean);

  const sorted = unique.sort((a, b) => {
    const aPriority = PRIORITY_CURRENCIES.indexOf(a);
    const bPriority = PRIORITY_CURRENCIES.indexOf(b);
    if (aPriority !== -1 || bPriority !== -1) {
      if (aPriority === -1) return 1;
      if (bPriority === -1) return -1;
      return aPriority - bPriority;
    }
    return a.localeCompare(b);
  });

  return sorted.map((code) => ({
    value: code,
    label: getCurrencyDisplayName(code),
  }));
}

export function resolveDefaultInvoiceCurrency(clientData) {
  const country = getClientCountryFromRecord(clientData);
  if (!country) return "AUD";
  const meta = resolveCountryMeta(country);
  return meta.currency_code || "AUD";
}

export function getInvoiceGstFormulaLabel(taxType) {
  if (taxType === "inclusive") {
    return "GST = Amount × Rate / (100 + Rate)";
  }
  if (taxType === "exclusive") {
    return "GST = Amount × Rate / 100";
  }
  return "";
}

export function getInvoiceGstHelperText(taxType, currency, gstAmount) {
  const formatted = Number(gstAmount) || 0;
  const amountLabel = formatted.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  if (taxType === "inclusive") {
    return `GST of ${currency} ${amountLabel} is included in the base cost.`;
  }
  if (taxType === "exclusive") {
    return `GST of ${currency} ${amountLabel} is added to the base cost.`;
  }
  return "";
}
